import React, { useState, useEffect } from 'react'
import '../HeaderComponent/Header.css';
import '../../Shared/css/common.css'
import { redirectToDealer, redirectToSupplier, redirectToVehicle, setTabStatusAction } from '../../../store/Actions/Lender/CommonAction/CommonAction';
import SearchIcon from '../../../assets/images/AssetSearchIcon.svg';
import globalSearchIcon from '../../../assets/images/OrganisationSearchIcon.svg'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import callAPI from '../../../commonservices/APIRequests';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { changeAuctionTab, changeTab, setHideNotificationIcon, updateMasterMenuById } from '../../../store/Reducers/Shared';
import { ISGETINVENTORYBYSEARCH, SETFILTERLABELTYPE } from '../../../store/Reducers/Lender/Inventory';
const GlobalSearchField = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const sharedReducerData = useSelector((store) => store.sharedReducer);
    const storeData = useSelector((store) => store.sharedReducer);
    const menuItems = storeData.userMenu;
    const { hideNotificationIcon } = useSelector((store) => store.sharedReducer);
    const userDetails = JSON.parse(localStorage.getItem('user'));
    const [orgSearchInput, setOrgSearchInput] = useState(false)
    const [assetSearchInput, setAssetSearchInput] = useState(false)
    const [searchResponseData, setSearchResponseData] = useState([])
    const [searchResult, setSearchResult] = useState("")
    const selectedRoutes = ["/Admin/ViewApplication", "/Admin/CreateDealer", "/Admin/CreateSupplier", '/Admin/ViewSupplierApplication']
    // global search
    const fetchSearchResults = () => {
        let req = {}
        req[orgSearchInput ? 'userTerm' : assetSearchInput ? 'assetTerm' : ''] = searchResult;
        if (sharedReducerData?.lenderSelectedSupplierDetails || sharedReducerData?.userDetails) {
            req.supplier_id = sharedReducerData?.lenderSelectedSupplierDetails._id ? sharedReducerData?.lenderSelectedSupplierDetails._id : sharedReducerData?.userDetails?._id
        }
        return callAPI.post('auth/api/v1/auth/handleSearch', req).then((resp) => {
            if (resp.status === 200) {
                setSearchResponseData(resp?.data?.users.length > 0 ? resp?.data?.users : resp?.data?.vehicles.length > 0 ? resp?.data?.vehicles : null)
            }
        })
    }

    const getSearchVisibility = (menuItems) => {
        const myDealers = menuItems.find(item => item.name === "My Dealers");
        const inner = myDealers?.innerItems || [];

        const names = inner.length > 0 && inner.map(i => i.name);
        return {
            shouldShowOrgSearch: names.length > 0 && names.includes("Dealers"),
            shouldShowAssetSearch:  names.length > 0 && names.includes("Inventory")
        };
    };


    const { shouldShowOrgSearch, shouldShowAssetSearch } = getSearchVisibility(menuItems);

    const hanldeClickNavigatePortal = (item) => {
        dispatch(updateMasterMenuById([]))
        dispatch(changeAuctionTab(''));
        dispatch(changeTab({ tab: '', isRedirect: true }))
        if (item?.sopraDealerId) {
            dispatch(redirectToDealer(item?._id, item?.status, "dealers", navigate))
        } else if (item?.sopraSupplierId) {
            dispatch(redirectToSupplier(item?._id, 'Auction', "suppliers", navigate))
        }
        setOrgSearchInput(false)
    }

    const hanldeClickNavigateProfile = (item) => {
        dispatch(setHideNotificationIcon(false))
        let userDetails
        if ((item?.organization?.toLowerCase() === 'dealer') || item?.organization?.toLowerCase() === 'application') {
            userDetails = { ...item, dealerId: item?._id }
            navigate('/Admin/ViewApplication',
                {
                    state: {
                        dealerDetails: userDetails,
                        backtoAccountManagement: 'Pending'
                    }
                }
            )
        } else if (item?.organization?.toLowerCase() === "supplier") {
            userDetails = { ...item, supplierId: item?._id }
            navigate('/Admin/ViewSupplierApplication',
                {
                    state: {
                        supplierDetails: userDetails,
                        backtoAccountManagement: 'Pending'
                    }
                }
            )
        }
        setOrgSearchInput(false)
    }
    const clearAssetInput = () => {
        setAssetSearchInput(!assetSearchInput);
        setOrgSearchInput(false);
        setSearchResponseData([])
        setSearchResult("")
    }

    const handleClickInventoryTab = async (vinDetails) => {
        vinDetails = { ...vinDetails, vehicleId: vinDetails?._id }
        if (userDetails?.organization?.toLowerCase() === 'lender' && !sharedReducerData?.lenderSelectedSupplierName) {
            dispatch(SETFILTERLABELTYPE({
                filterLabel: '',
                filterType: '',
                filtersData: {}
            }))
            await dispatch(setTabStatusAction('inventory', { vin: vinDetails?.vin }));
            dispatch(ISGETINVENTORYBYSEARCH(true))
            dispatch(setHideNotificationIcon(false))
            navigate('/Admin')
        } else if (userDetails?.organization?.toLowerCase() === 'supplier' || sharedReducerData?.lenderSelectedSupplierName) {
            vinDetails = { ...vinDetails, vehicleId: vinDetails?._id }
            dispatch(redirectToVehicle(vinDetails, userDetails?.organization?.toLowerCase() === 'supplier' ? 'supplier' : null, 'fundingrequests', navigate))
            dispatch(setHideNotificationIcon(false))
        }
        clearAssetInput()
    }
    const navigateToInventory = async () => {
        dispatch(SETFILTERLABELTYPE({
            filterLabel: '',
            filterType: '',
            filtersData: {}
        }))
        await dispatch(setTabStatusAction('inventory', { vin: searchResult }));
        dispatch(ISGETINVENTORYBYSEARCH(true))
        navigate('/Admin')
        clearAssetInput()
        dispatch(setHideNotificationIcon(false))
    }
    //enter key
    const handleKeyPress = (event) => {
        if (event.key === "Enter" && (userDetails?.organization?.toLowerCase() !== 'supplier' && !sharedReducerData?.lenderSelectedSupplierName)) {
            navigateToInventory()
        }
    }
    const handleChangeSearch = (e) => {
        const inputValue = e.target.value?.trimStart();
        let result
        if (e.target.name === "asset search") {
            result = inputValue.replace(/[^\w\s]/gi, "");
        } else {
            result = inputValue.replace(/[^-\w\s'&,’_.@/:+()!"`]/g, "");
        }
        setSearchResult(result);
        if (!inputValue)
            setSearchResponseData([])
    }
    const handleClickOrganizationSearchIcon = () => {
        dispatch(setHideNotificationIcon(!hideNotificationIcon))
        setOrgSearchInput(!orgSearchInput);
        setAssetSearchInput(false);
        setSearchResponseData([])
        setSearchResult("")
    }

    const hanldeClickAssetSearchIcon = () => {
        dispatch(setHideNotificationIcon(!hideNotificationIcon))
        if (searchResult && !sharedReducerData?.lenderSelectedSupplierName && userDetails?.organization?.toLowerCase() !== 'supplier') {
            navigateToInventory()
        } else {
            setAssetSearchInput(!assetSearchInput);
            setOrgSearchInput(false);
            setSearchResponseData([])
            setSearchResult("")
        }
    }
    useEffect(() => {
        const debouncedSearch = setTimeout(() => {
            if (searchResult?.length >= 3)
                fetchSearchResults();
        }, 600);

        return () => {
            clearTimeout(debouncedSearch);
        };
    }, [searchResult]);
    return (
        <div className={`d-flex mr-2 ${selectedRoutes?.includes(location?.pathname) ? 'global-search-field' : null}`}>
            {userDetails?.organization?.toLowerCase() === 'lender' ? <div className={`${orgSearchInput ? 'suggestion-search-on' : 'suggestion-search-off'} input-search-header`}>
                {shouldShowOrgSearch && (
                    <div className={`${orgSearchInput ? 'clicked-search pr-2' : 'close-search'} d-flex align-items-center`}>
                        <div>
                            <input type="text" name="organization search" placeholder='Organization Search' value={searchResult} onChange={handleChangeSearch} />
                        </div>
                        {!assetSearchInput && <div>
                            <OverlayTrigger placement='bottom' overlay={<Tooltip>Organization Search</Tooltip>}>
                                <img src={globalSearchIcon} fluid alt='Search-Icon' className='search-icon-header cursor-pointer' onClick={handleClickOrganizationSearchIcon} />
                            </OverlayTrigger>
                        </div>}
                    </div>)}
                {orgSearchInput && searchResponseData?.length > 0 ?
                    <div className='dropdown-suggestion'>
                        {searchResponseData?.filter((item1) => item1?.sopraDealerReference ? (item1?.sopraDealerReference + item1?.dealerName)?.toLowerCase()?.includes(searchResult?.toLowerCase()) :
                            (item1?.sopraSupplierReference + item1?.dealerName)?.toLowerCase()?.includes(searchResult?.toLowerCase())
                        )?.map((user, index) => {
                            return (
                                <div key={index} className='suggestion-item px-2 d-flex justify-content-between align-items-center'>
                                    <p>{user?.dealerName + (user?.sopraDealerReference ? "(" + user?.sopraDealerReference + ")" : user?.sopraSupplierReference ? "(" + user?.sopraSupplierReference + ")" : "")}</p>
                                    <div>
                                        <Button type='button' className='default-btn small-btn' onClick={() => hanldeClickNavigateProfile(user)}>Profile</Button>
                                        {(user?.sopraDealerId || user?.sopraSupplierId) ? <Button type='button' className='default-btn small-btn ml-2' onClick={() => hanldeClickNavigatePortal(user)}>Portal</Button> : null}
                                    </div>
                                </div>
                            )
                        })}
                    </div> : orgSearchInput && searchResult?.length >= 3 ?
                        <div className='dropdown-suggestion'>
                            <div className='suggestion-item px-2 d-flex justify-content-between align-items-center'>
                                {!searchResponseData ? <p>No Results Found!</p> : <p>Data is processing...</p>}
                            </div>
                        </div> : null
                }
            </div> : null}
            <div className={`${assetSearchInput ? 'suggestion-search-on' : 'suggestion-search-off'} input-search-header`}>
                {shouldShowAssetSearch && (
                    <div className={`${assetSearchInput ? 'clicked-search pr-2' : 'close-search'} d-flex align-items-center`}>
                        <div>
                            <input type="text" name="asset search" placeholder='Asset Search' value={searchResult} onChange={handleChangeSearch} onKeyPress={handleKeyPress} />
                        </div>
                        {!orgSearchInput && <div>
                            <OverlayTrigger placement='bottom' overlay={<Tooltip>Asset Search</Tooltip>}>
                                <img src={SearchIcon} fluid alt='Search-Icon' className='search-icon-header cursor-pointer' onClick={hanldeClickAssetSearchIcon} />
                            </OverlayTrigger>
                        </div>}
                    </div>
                )}
                {assetSearchInput && searchResponseData?.length > 0 ?
                    <div className='dropdown-suggestion cursor-pointer'>
                        {searchResponseData?.filter((item1) => (item1?.vin?.toLowerCase() + (item1?.vehicleName ? item1?.vehicleName.toLowerCase() : "") + (item1?.lmsLoanId ? item1?.lmsLoanId : ""))?.includes(searchResult?.toLowerCase())
                        )?.map((user, index) => {
                            return (
                                <div key={index} className='suggestion-item px-2 d-flex justify-content-between align-items-center'
                                    onClick={() => handleClickInventoryTab(user)}
                                >
                                    <p>{`${user?.vehicleName ? user?.vehicleName : ""} (${user?.vehicleName ? user?.vin?.slice(-6) : user?.vin})`}</p>
                                </div>
                            )
                        })}
                    </div> :
                    assetSearchInput && searchResult?.length >= 3 ?
                        <div className='dropdown-suggestion'>
                            <div className='suggestion-item px-2 d-flex justify-content-between align-items-center'>
                                {!searchResponseData ? <p>No Results Found!</p> : <p>Data is processing...</p>}
                            </div>
                        </div> : null
                }
            </div>

        </div>
    )
}

export default GlobalSearchField